import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AllStaff.css";

const BASE_URL = "/api/admin/staff";

const AllStaff = () => {
  const [staffList, setStaffList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(BASE_URL, {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        });
        setStaffList(response.data);
        setFilteredList(response.data);
      } catch (err) {
        console.error(err);
        setError("Failed to load staff data");
      } finally {
        setLoading(false);
      }
    };
    fetchStaff();
  }, []);

  // 🔍 Global Search Filter
  useEffect(() => {
    const filtered = staffList.filter((staff) =>
      Object.values(staff)
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    );
    setFilteredList(filtered);
  }, [search, staffList]);

  // ✂️ Truncate Long Text
  const truncateText = (text, length = 40) => {
    if (!text) return "—";
    return text.length > length ? text.slice(0, length) + "…" : text;
  };

  if (loading) return <div className="loading">Loading staff...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="staff-container">
      <div className="staff-header">
        <h2>All Staff</h2>
        <input
          type="text"
          placeholder="Search staff..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="staff-search"
        />
      </div>

      <table className="staff-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Staff Code</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Description</th>
            <th>Society</th>
          </tr>
        </thead>
        <tbody>
          {filteredList.length > 0 ? (
            filteredList.map((staff) => (
              <tr key={staff.id}>
                <td data-label="ID">{staff.id}</td>
                <td data-label="Staff Code">{staff.staffCode}</td>
                <td data-label="Name">{staff.name}</td>
                <td data-label="Phone">{staff.phoneNumber}</td>
                <td data-label="Description" title={staff.description}>
                  {truncateText(staff.description, 35)}
                </td>
                <td data-label="Society">{staff.societyName}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                No matching staff found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AllStaff;
